import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../../config";
import { capitalizeFirstLetter } from "../../../utils/Utils";
import {
  Box, Typography, Avatar, Table, TableBody,
  TableCell, TableHead, TableRow, Chip,
} from "@mui/material";
import { connect } from "react-redux";

const headCellSx = { color: "#555", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", whiteSpace: "nowrap", borderColor: "#222", backgroundColor: "#111" };

const ActiveOrdersTable = ({ seller, jwtToken }) => {
  const headings = ["", "Name", "Category", "Sub-Category", "Status", "Price"];
  const [serviceListings, setServiceListings] = useState([]);

  useEffect(() => {
    if (!seller?.id) return;
    const fetchServices = async () => {
      try {
        const res = await axios.get(
          `${config.SERVER_URL}/api/v1/listing_services?filter_status=all`,
          {
            headers: { Authorization: `Bearer ${jwtToken}` },
            params: { seller_id: seller.id },
          }
        );
        if (res.status === 200) setServiceListings(res.data.data || []);
      } catch {}
    };
    fetchServices();
  }, [jwtToken, seller]);

  return (
    <Box sx={{ backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "16px", overflow: "hidden" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 2.5, py: 1.5, borderBottom: "1px solid #222" }}>
        <Typography sx={{ fontWeight: 700, fontSize: "14px", color: "#fff" }}>
          Active Services
        </Typography>
        <Typography sx={{ color: "#555", fontSize: "12px" }}>
          {serviceListings.length} total
        </Typography>
      </Box>

      <Box sx={{ overflowX: "auto" }}>
        {serviceListings.length > 0 ? (
          <Table size="small" sx={{ "& td": { borderColor: "#1e1e1e" } }}>
            <TableHead>
              <TableRow>
                {headings.map(h => (
                  <TableCell key={h} align="center" sx={headCellSx}>{h}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {serviceListings.map((data) => (
                <TableRow
                  key={data.id}
                  onClick={() => window.open(
                    `/services/${data.service_id}/subService/${data.sub_service_id}/listings/${data.id}`,
                    "_blank"
                  )}
                  sx={{ cursor: "pointer", "&:hover": { backgroundColor: "rgba(255,192,1,0.03)" } }}
                >
                  <TableCell align="center" sx={{ py: 1, borderColor: "#1e1e1e", width: 52 }}>
                    <Avatar src={data.media?.[0]?.url} alt={data.name} sx={{ width: 36, height: 36, mx: "auto" }} />
                  </TableCell>
                  <TableCell align="center" sx={{ color: "#ccc", fontSize: "13px", borderColor: "#1e1e1e" }}>
                    {data.name}
                  </TableCell>
                  <TableCell align="center" sx={{ color: "#888", fontSize: "13px", borderColor: "#1e1e1e" }}>
                    {data.service?.name}
                  </TableCell>
                  <TableCell align="center" sx={{ color: "#888", fontSize: "13px", borderColor: "#1e1e1e" }}>
                    {data.sub_service?.name}
                  </TableCell>
                  <TableCell align="center" sx={{ borderColor: "#1e1e1e" }}>
                    <Chip
                      label={capitalizeFirstLetter(data.status.split("_")[0])}
                      size="small"
                      sx={{ backgroundColor: "rgba(76,175,80,0.1)", color: "#4caf50", fontSize: "11px", fontWeight: 700, height: 22, border: "1px solid rgba(76,175,80,0.2)" }}
                    />
                  </TableCell>
                  <TableCell align="center" sx={{ color: "#FFC001", fontSize: "13px", fontWeight: 700, borderColor: "#1e1e1e" }}>
                    ${data.price}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography sx={{ color: "#555", fontSize: "13px", textAlign: "center", py: 4 }}>
            No services found
          </Typography>
        )}
      </Box>
    </Box>
  );
};

const mapStateToProps = ({ Auth, Seller }) => ({
  jwtToken: Auth.jwtToken,
  seller: Seller.seller,
});
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ActiveOrdersTable);
